import { useEffect, useMemo } from 'react';
import { useCategorizeTransactionMutation } from '../../../hooks/mutations/useCategorizeTransactionMutation';
import { ICategory, ITransaction } from '../../../types';
import { useTransactionsCategoriesQuery } from '../../../hooks/query/useTransactionsCategoriesQuery';

export const DEFAULT_TAX_ID = 'ECC7C222-5018-6AF3-9782-C2F296E16BB0';

export const DEFAULT_INCOME_TAX_ID = '6c5e839e-9ca5-47e9-9daa-6245cdc75d47';

export const useCategorizationHook = (customerId: string) => {
  const { mutate: categorizeTransaction } = useCategorizeTransactionMutation();
  const { data: transactionsCategories, refetch: getTransactionsCategories } = useTransactionsCategoriesQuery({ customerId });
  const expenseCategories = useMemo(() => {
    if (!transactionsCategories) return [];
    return transactionsCategories?.categories.filter((c: ICategory) => c.transactionType === 'EXPENSE');
  }, [transactionsCategories]);
  const incomeCategories = useMemo(() => {
    if (!transactionsCategories) return [];
    return transactionsCategories?.categories.filter((c: ICategory) => c.transactionType === 'INCOME');
  }, [transactionsCategories]);
  const categorizeAction = async (transaction: ITransaction, categoryId: string, businessPercent: number | null) => {
    if ((businessPercent !== null && categoryId) || (businessPercent === 0 && !categoryId)) {
      await categorizeTransaction({
        customerId,
        transactionId: transaction?.transactionId,
        categoryDetails: {
          categoryId: categoryId || null,
          businessPercent,
        },
      });
      return true;
    }
    return false;
  };

  useEffect(() => {
    getTransactionsCategories();
  }, []);

  return {
    categorizeAction,
    expenseCategories,
    incomeCategories,
  };
};
